import React from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { Link } from "react-router-dom";
import Select from "react-select";

import {
  FORGOT_PASSWORD,
  colourStyles,
  colourStylesVariant,
} from "../data/Constants";

const FormField = ({
  label,
  name,
  type,
  fieldSize,
  isForgotPasswordField,
  selectOptions,
  footerPlaceholder,
  labelFontColor,
}) => {
  const { setFieldValue } = useFormikContext();

  // Render form input according to input type (type via props)
  let inputElement;

  if (type === "select") {
    // For Select input type
    inputElement = (
      <Select
        isSearchable={false}
        styles={colourStyles}
        options={selectOptions}
        components={{
          IndicatorSeparator: () => null,
        }}
        onChange={(valueObj) => setFieldValue(name, valueObj?.value)}
      />
    );
  } else if (type === "identity_type") {
    // For combined Select and number input
    const { identity_type, identity_number } = name;
    inputElement = (
      <div className="d-flex flex-column">
        <div className="center-alignment">
          <Select
            isSearchable={false}
            styles={colourStylesVariant}
            options={selectOptions}
            components={{
              IndicatorSeparator: () => null,
            }}
            className="form-field-identity-type"
            onChange={(valueObj) =>
              setFieldValue(identity_type, valueObj?.value)
            }
          />
          <div className="field-separator-bg">
            <div className="field-separator"></div>
          </div>
          <Field
            type="text"
            id={label}
            name={identity_number}
            className="form-control form-field-identity-number"
            autoComplete="off"
          />
        </div>
        <div className="d-flex gap-2">
          <div className="form-field-identity-type">
            <ErrorMessage
              name={identity_type}
              component="div"
              className="text-danger fs-14 fw-400 mt-1"
            />
          </div>
          <div className="w-74">
            <ErrorMessage
              name={identity_number}
              component="div"
              className="text-danger fs-14 fw-400 mt-1"
            />
          </div>
        </div>
      </div>
    );
  } else {
    // For other input types
    inputElement = (
      <Field
        type={type}
        id={label}
        name={name}
        className="form-control"
        autoComplete="off"
      />
    );
  }

  return (
    <div
      className={`${fieldSize} d-flex flex-column`}
      style={{ marginTop: "20px" }}
    >
      <div className="d-flex justify-content-between">
        {/* Input label */}
        <label
          htmlFor={label}
          className={`${
            labelFontColor ? labelFontColor : "text-gray-300"
          } fs-6 mb-2 fw-400`}
        >
          {label}
        </label>
        {/* Forgot password link for login form */}
        {isForgotPasswordField && (
          <Link
            className="text-gray-300 fs-6 fw-400 text-primary-sapphire text-decoration-none cursor-pointer"
            to={FORGOT_PASSWORD}
          >
            Forgot Password?
          </Link>
        )}
        {/* forgot password link for login form end */}
      </div>
      {/* Input field */}
      {inputElement}
      {/* Footer placeholder for registration and login forms */}
      {footerPlaceholder && (
        <div className="text-gray-150 fs-14 fw-400 mt-1">
          {footerPlaceholder}
        </div>
      )}
      {/* Error message */}
      <ErrorMessage
        name={name}
        component="div"
        className="text-danger fs-14 fw-400 mt-1"
      />
    </div>
  );
};

export default FormField;
